import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectCurrentContractActive } from '../../../SubscriptionForm/SubscriptionFormSelectors'

const useZohoButton = () => {
  const { t } = useTranslation()
  const { zohoContractId = null } = useSelector(selectCurrentContractActive) || {}

  return { t, zohoContractId }
}

export default useZohoButton
